"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupOrderLinesByDate = void 0;
const dayjs = require("dayjs");
const advancedFormat = require("dayjs/plugin/advancedFormat");
dayjs.extend(advancedFormat);
const groupOrderLinesByDate = (order_lines) => {
    const grouped_lines = [];
    const regions = order_lines.map((line) => {
        return line.region_id;
    });
    const unique_regions = regions.filter((value, index, self) => self.indexOf(value) === index);
    order_lines.forEach((line, idx) => {
        const date = line.start_date;
        const existing_group = grouped_lines.find((group) => group.date === date);
        if (existing_group) {
            existing_group.order_lines.push(line);
        }
        else {
            grouped_lines.push({
                date: date,
                date_friendly: dayjs(date).format("ddd, Do MMM YYYY"),
                order_lines: [line],
            });
        }
    });
    // order each order_lines by region_id then by order_weight
    grouped_lines.forEach((group) => {
        group.order_lines.sort((a, b) => {
            if (a.region_id === b.region_id) {
                return a.order_weight - b.order_weight;
            }
            else {
                return (unique_regions.indexOf(a.region_id) -
                    unique_regions.indexOf(b.region_id));
            }
        });
    });
    // Sort the grouped_lines by date first
    grouped_lines.sort((a, b) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
    });
    // Calculate day gaps and create missing objects for single-day gaps
    const result_lines = [];
    grouped_lines.forEach((group, idx) => {
        if (idx === 0) {
            group.days_diff = 0;
            group.has_gap = false;
            group.multi_day_gap = false;
            result_lines.push(group);
        }
        else {
            const prev_group = result_lines[result_lines.length - 1];
            const current_date = dayjs(group.date);
            const prev_date = dayjs(prev_group.date);
            const days_diff = current_date.diff(prev_date, "day") - 1;
            group.days_diff = days_diff;
            group.has_gap = days_diff > 0;
            group.multi_day_gap = days_diff > 1;
            // If there's exactly a 1-day gap, create the missing date object
            if (days_diff === 1) {
                const missing_date = prev_date.add(1, "day");
                const missing_date_str = missing_date.format("YYYY-MM-DD");
                const missing_date_friendly = missing_date.format("ddd, Do MMM YYYY");
                result_lines.push({
                    date: missing_date_str,
                    date_friendly: missing_date_friendly,
                    order_lines: [],
                    days_diff: 0,
                    has_gap: false,
                    multi_day_gap: false,
                });
            }
            result_lines.push(group);
        }
    });
    return result_lines;
};
exports.groupOrderLinesByDate = groupOrderLinesByDate;
